import { AdyenActionComponent, useCartFulfill3ds } from "@apac/checkout";
import { CartFulfillErrorModal } from "@apac/ui";
import { Funnel } from "@b2bportal/core-types";
import {
  DesktopLayout,
  cartFulfillSelectors,
  useCheckoutStateSelector as useSelector,
} from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import { B2BSpinner } from "@hopper-b2b/ui";
import { useDeviceTypes } from "@hopper-b2b/utilities";
import type { FlightMachineContext } from "@hsbc/types";
import { getClientAssets } from "../../selectors";
import { CartLoadingScreen } from "../CartQuoteComponent/CartLoadingScreen";
import { ConnectedPriceBreakdownContent } from "../PriceBreakdownDropdown";

import "./styles.scss";
export const CartFulfillComponent = () => {
  const { t, brand } = useI18nContext();
  const { matchesMobile } = useDeviceTypes();
  const openCartFulfillModal = useSelector(
    cartFulfillSelectors.getOpenCartFulfillModal
  );
  const openCartFulfillErrorModal = useSelector(
    cartFulfillSelectors.getOpenCartFulfillErrorModal
  );
  const clientAssets = useSelector(getClientAssets);
  const {
    paymentAction,
    on3DSDialogOpenChange,
    should3DSDialogOpen,
    on3dsSuccess,
    on3dsError,
  } = useCartFulfill3ds<FlightMachineContext>();

  return (
    <>
      {!matchesMobile ? (
        <DesktopLayout
          clientLogo={clientAssets?.logo}
          rightContent={<ConnectedPriceBreakdownContent />}
        >
          <B2BSpinner />
        </DesktopLayout>
      ) : null}
      {openCartFulfillModal ? (
        <CartLoadingScreen
          isLoading
          loadingSteps={[{ title: t("scheduleFulfillLoading.title") }]}
        />
      ) : null}
      {openCartFulfillErrorModal && (
        <CartFulfillErrorModal funnel={Funnel.Air} />
      )}
      {paymentAction != null && (
        <AdyenActionComponent
          paymentAction={paymentAction}
          on3DSDialogOpenChange={on3DSDialogOpenChange}
          should3DSDialogOpen={should3DSDialogOpen}
          locale={"en-US"}
          countryCode={brand?.preferredCountryCode || "SG"}
          onSuccess={on3dsSuccess}
          onError={on3dsError}
        />
      )}
    </>
  );
};
